export const Pharmasee = () => (
  <path d='M21.3,2.8c-1.1-1.1-2.5-1.7-4-1.7s-3,0.6-4.1,1.7L2.7,13.2c-1.1,1.1-1.7,2.5-1.7,4c0,1.6,0.6,3,1.7,4c1.1,1.1,2.5,1.7,4,1.7s3-0.6,4.1-1.7l10.4-10.4c1.1-1.1,1.7-2.5,1.7-4S22.3,3.8,21.3,2.8z M9.7,20.2c-0.7,0.7-1.8,1.2-2.9,1.2S4.7,21,4,20.2c-0.7-0.8-1.2-1.8-1.2-2.9s0.4-2.1,1.2-2.9l4.7-4.7l5.8,5.8L9.7,20.2z' />
)
